import { useTranslation } from 'react-i18next';
import { KIOSK__DISCARD_REGISTRATION_BUTTON } from 'translations/constants';
import { ReactComponent as DeleteSmallWhiteIcon } from '../../../assets/icons/DeleteSmallWhite.svg';
import { KioskDiscardActionButton, KioskDiscardActionText } from '../styles';

interface KioskDiscardActionProps {
  onClick: () => void;
  disabled: boolean;
  testId: string;
}

const KioskDiscardAction = ({ onClick, disabled, testId }: KioskDiscardActionProps) => {
  const [t] = useTranslation();
  return (
    <KioskDiscardActionButton onClick={onClick} disabled={disabled} data-testid={testId}>
      <DeleteSmallWhiteIcon />
      <KioskDiscardActionText>{t(KIOSK__DISCARD_REGISTRATION_BUTTON)}</KioskDiscardActionText>
    </KioskDiscardActionButton>
  );
};

export default KioskDiscardAction;
